import React from "react";
import Home from "./Home";
import Destination from "./Destination";
import International from './International'
import Services from './Services'
import WhyChoose from './WhyChoose'
import CTA from './CTA'
export default function HomeApp(){
    return(
        <>
        <Home/>
        <Destination/>
        <International/>
        <Services/>
        <WhyChoose/>
        <CTA/>
        
        </>
    )
}